// create_investor_investorTransaction
export const INVESTOR_ASSIGN_SHARES = 'create_investor_investorTransaction';
export const INVESTOR_ASSIGN_SHARES_SUCCESSFUL =
  'create_investor_investorTransaction_successfull';
export const INVESTOR_ASSIGN_SHARES_FAILED =
  'create_investor_investorTransaction_failed';

// get_investor_investorTransactions
export const GET_INVESTOR_TRANSACTIONS = 'get_investor_investorTransactions';
export const GET_INVESTOR_TRANSACTIONS_SUCCESSFUL =
  'get_investor_investorTransactions_successfull';
export const GET_INVESTOR_TRANSACTIONS_FAILED =
  'get_investor_investorTransactions_failed';

// investor_assign_price
export const INVESTOR_ASSIGN_PRICE = 'investor_assign_price';
export const INVESTOR_ASSIGN_PRICE_SUCCESSFUL =
  'investor_assign_price_successfull';
export const INVESTOR_ASSIGN_PRICE_FAILED = 'investor_assign_price_failed';

// get_share_prices
export const GET_SHARE_PRICES = 'get_share_prices';
export const GET_SHARE_PRICES_SUCCESSFUL = 'get_share_prices_successfull';
export const GET_SHARE_PRICES_FAILED = 'get_share_prices_failed';

// get_investor_transactions_of_user
export const GET_INVESTOR_TRANSACTIONS_OF_USER =
  'get_investor_transactions_of_user';
export const GET_INVESTOR_TRANSACTIONS_OF_USER_SUCCESSFUL =
  'get_investor_transactions_of_user_successfull';
export const GET_INVESTOR_TRANSACTIONS_OF_USER_FAILED =
  'get_investor_transactions_of_user_failed';

// update_investor_share_price
export const UPDATE_INVESTOR_SHARE_PRICE = 'update_investor_share_price';
export const UPDATE_INVESTOR_SHARE_PRICE_SUCCESSFUL =
  'update_investor_share_price_successfull';
export const UPDATE_INVESTOR_SHARE_PRICE_FAILED =
  'update_investor_share_price_failed';

// delete_investor_share_price
export const DELETE_INVESTOR_SHARE_PRICE = 'delete_investor_share_price';
export const DELETE_INVESTOR_SHARE_PRICE_SUCCESSFUL =
  'delete_investor_share_price_successfull';
export const DELETE_INVESTOR_SHARE_PRICE_FAILED =
  'delete_investor_share_price_failed';

// update_investor_assign_share
export const UPDATE_INVESTOR_ASSIGN_SHARE = 'update_investor_assign_share';
export const UPDATE_INVESTOR_ASSIGN_SHARE_SUCCESSFUL =
  'update_investor_assign_share_successfull';
export const UPDATE_INVESTOR_ASSIGN_SHARE_FAILED =
  'update_investor_assign_share_failed';

// delete_investor_assign_share
export const DELETE_INVESTOR_ASSIGN_SHARE = 'delete_investor_assign_share';
export const DELETE_INVESTOR_ASSIGN_SHARE_SUCCESSFUL =
  'delete_investor_assign_share_successfull';
export const DELETE_INVESTOR_ASSIGN_SHARE_FAILED =
  'delete_investor_assign_share_failed';

// get_all_investor_users
export const GET_ALL_INVESTOR_USERS = 'get_all_investor_users';
export const GET_ALL_INVESTOR_USERS_SUCCESSFUL =
  'get_all_investor_users_successfull';
export const GET_ALL_INVESTOR_USERS_FAILED = 'get_all_investor_users_failed';
